import Swiper from 'swiper/bundle';
import { animationDuration } from '~/javascripts/utils/testing';

document.addEventListener('DOMContentLoaded', () => {
  Swiper.defaults.speed = animationDuration(300);
});
